import loadable from '@loadable/component';

export const ActivateInsuranceLoadable = loadable(() => import('./ActivateInsurance'), {
  fallback: null,
  ssr: false,
});
